import { Text, ActionIcon, Tooltip, Box, Group, Stack } from '@mantine/core';
import Plus from 'lucide-react/dist/esm/icons/plus';
import Trash2 from 'lucide-react/dist/esm/icons/trash-2';
import Film from 'lucide-react/dist/esm/icons/film';
import Music from 'lucide-react/dist/esm/icons/music';
import { Panel } from '../../../shared/components/Panel';
import type { MediaBinItem } from '../types';
import { formatTime, isAudioFile } from '../utils';
import classes from './MediaBin.module.css';

export function MediaBin({ items, onAddFile, onRemoveItem, onAppendAsSegment }: {
  items: MediaBinItem[]; onAddFile: () => void; onRemoveItem: (id: string) => void; onAppendAsSegment: (item: MediaBinItem) => void;
}) {
  return (
    <Panel
      title={<Group gap="xs" align="center" wrap="nowrap"><Film size={16} style={{ flexShrink: 0 }} /><span>Корзина проекта</span></Group>}
      info="Project Bin: перетаскивайте медиафайлы на таймлайн или добавляйте по клику на «+»."
      headerRight={<Tooltip label="Добавить файл" withArrow><ActionIcon variant="subtle" color="blue" onClick={onAddFile} aria-label="Добавить файл"><Plus size={18} /></ActionIcon></Tooltip>}
    >
      {items.length === 0 ? (
        <Box className={classes.emptyDropzone} onClick={onAddFile}>
          <Stack gap={4} align="center"><Film size={24} style={{ color: 'var(--mantine-color-dimmed)' }} /><Text fz="sm" fw={500}>Корзина пуста</Text><Text fz="xs" c="dimmed">Нажмите, чтобы добавить видео или аудио с сервера</Text></Stack>
        </Box>
      ) : (
        <div className={classes.grid}>
          {items.map(item => {
            const isAud = isAudioFile(item.name) || !item.width;
            return (
              <div key={item.id} className={classes.card} draggable title={item.path} onDragStart={e => { e.dataTransfer.setData('text/plain', item.path); e.dataTransfer.effectAllowed = 'copy'; }}>
                <div className={classes.cardIconWrapper}>
                  {isAud ? <Music size={22} style={{ color: 'var(--mantine-color-blue-4)' }} /> : <Film size={22} style={{ color: 'var(--mantine-color-brand-4)' }} />}
                  {item.duration ? <span className={classes.durationBadge}>{formatTime(item.duration)}</span> : null}
                  <div className={classes.cardActions}>
                    <Tooltip label="Добавить на таймлайн" withArrow position="top"><ActionIcon variant="filled" color="blue" size="sm" onClick={e => { e.stopPropagation(); onAppendAsSegment(item); }}><Plus size={14} /></ActionIcon></Tooltip>
                    <Tooltip label="Убрать из проекта" withArrow position="top"><ActionIcon variant="filled" color="red" size="sm" onClick={e => { e.stopPropagation(); onRemoveItem(item.id); }}><Trash2 size={13} /></ActionIcon></Tooltip>
                  </div>
                </div>
                <span className={classes.fileName}>{item.name}</span>
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
